import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Module } from 'components/misc'
import { Input, Select } from 'components/fields'
import { apiCodeLists } from 'helpers/decorators/api'

import styles from './financial-data.styl'

@apiCodeLists(['invoiceCurrencies', 'vatTreatments'])
class FinancialData extends PureComponent {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    showPrfDisc: PropTypes.bool
  }

  static defaultProps = {
    showPrfDisc: true
  }

  render() {
    const { codeLists, showPrfDisc } = this.props

    return (
      <Module
        primary
        grid
        intlKey="moduleTitle.finance_system_data"
        title="Finance System Data"
      >
        <div className="row">
          <div className="col-xs-5">
            <Input
              label="Exchequer A/c No."
              intlKey="label.exchequer_number"
              name="exchequerNumber"
            />
          </div>
          <div className="col-xs-3">
            <Select
              label="Invoice Currency"
              intlKey="label.invoice_currency"
              name="invoiceCurrencyType.value"
              options={codeLists.invoiceCurrencies.list}
            />
          </div>
          <div className="col-xs-4">
            <Select
              label="VAT Treatment"
              intlKey="label.vat_treatment"
              name="vatTreatmentType.value"
              options={codeLists.vatTreatments.list}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-5">
            <Input
              label="VAT No."
              intlKey="label.vat_number"
              name="vatNumber"
            />
          </div>
          <div className="col-xs-3">
            <Input
              className={styles.gnipp}
              label="GNIPP"
              intlKey="label.gnipp"
              name="gnippPercentage"
              normalize={value => (!isNaN(value) ? value.trim() : undefined)}
            />
          </div>
          {showPrfDisc &&
          <div className="col-xs-3">
            <Input
              className={styles.prfDisc}
              label="PRF Disc"
              intlKey="label.prf_disc"
              name="prfDiscPercentage"
              type="number"
              min={0}
              max={100}
              normalize={value => (!isNaN(value) ? value.trim() : undefined)}
            />
          </div>}
        </div>
      </Module>
    )
  }
}

export default FinancialData
